import { base_colorAction } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(3)};
  margin-top: auto;

  .integration-card-indicator {
    display: flex;
    align-items: center;
    gap: ${spacing(1)};
    color: ${base_colorAction};
    font-family: ${font_family_weight_medium};
    ${font_md};
  }

  .integration-card-indicator.connect svg,
  .integration-card-indicator.incomplete svg {
    flex-shrink: 0;
    transform: scale(calc(16 / 24));
  }

  .integration-card-indicator.connected svg {
    flex-shrink: 0;
    transform-origin: left;
  }

  .integration-card-indicator.loading svg {
    flex-shrink: 0;
    transform: scale(0.75);
  }

  .integration-card-indicator.manage svg {
    flex-shrink: 0;
    margin-left: ${spacing(1)};
    transform: scale(calc(16 / 24));
    transform-origin: left;
  }

  .integration-card-indicator.muted {
    opacity: 0.5;
  }
`
